function parseDateInput(date) {
    if (date === undefined || date === null || date === '')
        return undefined;
    const dateObj = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(dateObj.getTime())) {
        return undefined;
    }
    return dateObj;
}
/**
 * Formats calendar dates for frontend display using the user's locale.
 * UTC is intentional so content-authored dates do not shift by viewer timezone.
 */
export function formatUtcDateForUserLocale(date, options) {
    const dateObj = parseDateInput(date);
    if (!dateObj)
        return undefined;
    return new Intl.DateTimeFormat(undefined, {
        month: options.month,
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC',
    }).format(dateObj);
}
/**
 * Formats deterministic UTC calendar dates as MM/DD/YYYY.
 */
export function formatUtcMmDdYyyyDate(date) {
    const dateObj = parseDateInput(date);
    if (!dateObj)
        return '';
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getUTCDate()).padStart(2, '0');
    const year = dateObj.getUTCFullYear();
    return `${month}/${day}/${year}`;
}
//# sourceMappingURL=formatDate.js.map